export const COUNTRY_TRANSLATIONS = {
  "World": "Internacional",
  "France": "Francia",
  "Belgium": "Bélgica",
  "Brazil": "Brasil",
  "England": "Inglaterra",
  "Germany": "Alemania",
  "Italy": "Italia",
  "Netherlands": "Países Bajos",
  "Portugal": "Portugal",
  "Spain": "España",
  "Scotland": "Escocia",
  "Lebanon": "Líbano",
  "Luxembourg": "Luxemburgo",
  "Qatar": "Catar",
  "Suriname": "Surinam",
  "Tajikistan": "Tayikistán",
  "Palestine": "Palestina",
  "Trinidad-And-Tobago": "Trinidad y Tobago",
  "Trinidad & Tobago": "Trinidad y Tobago",
  "Ukraine": "Ucrania",
  "United-Arab-Emirates": "Emiratos Árabes Unidos",
  "United Arab Emirates": "Emiratos Árabes Unidos",
  "Uruguay": "Uruguay",
  "Tunisia": "Túnez",
  "Turkey": "Turquía",
  "Algeria": "Argelia",
  "Albania": "Albania",
  "Andorra": "Andorra",
  "Argentina": "Argentina",
  "Australia": "Australia",
  "Austria": "Austria",
  "Azerbaijan": "Azerbaiyán",
  "Wales": "Gales",
  "Venezuela": "Venezuela",
  "Oman": "Omán",
  "Jamaica": "Jamaica",
  "Jordan": "Jordania",
  "Kazakhstan": "Kazajistán",
  "Kuwait": "Kuwait",
  "Denmark": "Dinamarca",
  "Honduras": "Honduras",
  "Hong-Kong": "Hong Kong",
  "Hong Kong": "Hong Kong",
  "Hungary": "Hungría",
  "Egypt": "Egipto",
  "El-Salvador": "El Salvador",
  "El Salvador": "El Salvador",
  "Estonia": "Estonia",
  "Georgia": "Georgia",
  "Ghana": "Ghana",
  "Guadeloupe": "Guadalupe",
  "Guatemala": "Guatemala",
  "Greece": "Grecia",
  "Barbados": "Barbados",
  "Latvia": "Letonia",
  "Lithuania": "Lituania",
  "Uganda": "Uganda",
  "Mali": "Malí",
  "USA": "Estados Unidos",
  "Uzbekistan": "Uzbekistán",
  "Thailand": "Tailandia",
  "Faroe-Islands": "Islas Feroe",
  "Faroe Islands": "Islas Feroe",
  "Finland": "Finlandia",
  "Ecuador": "Ecuador",
  "Angola": "Angola",
  "Armenia": "Armenia",
  "Belarus": "Bielorrusia",
  "Zambia": "Zambia",
  "Vietnam": "Vietnam",
  "Japan": "Japón",
  "Kenya": "Kenia",
  "Haiti": "Haití",
  "Singapore": "Singapur",
  "Aruba": "Aruba",
  "Fiji": "Fiyi",
  "Guinea": "Guinea",
  "Chile": "Chile",
  "Ethiopia": "Etiopía",
  "Tanzania": "Tanzania",
  "Czech-Republic": "República Checa",
  "Czech Republic": "República Checa",
  "Kyrgyzstan": "Kirguistán",
  "Sweden": "Suecia",
  "Norway": "Noruega",
  "Costa-Rica": "Costa Rica",
  "Costa Rica": "Costa Rica",
  "Iceland": "Islandia",
  "China": "China",
  "Morocco": "Marruecos",
  "Switzerland": "Suiza",
  "Croatia": "Croacia",
  "Russia": "Rusia",
  "Colombia": "Colombia",
  "Paraguay": "Paraguay",
  "Bulgaria": "Bulgaria",
  "Mexico": "México",
  "Canada": "Canadá",
  "Malaysia": "Malasia",
  "New-Zealand": "Nueva Zelanda",
  "New Zealand": "Nueva Zelanda",
  "Peru": "Perú",
  "Romania": "Rumania",
  "Serbia": "Serbia",
  "South-Africa": "Sudáfrica",
  "South Africa": "Sudáfrica",
  "Iran": "Irán",
  "South-Korea": "Corea del Sur",
  "South Korea": "Corea del Sur",
  "North Korea": "Corea del Norte",
  "Saudi Arabia": "Arabia Saudita",
  "Iraq": "Irak",
  "Syria": "Siria",
  "Libya": "Libia",
  "Nigeria": "Nigeria",
  "Senegal": "Senegal",
  "Cameroon": "Camerún",
  "Ivory Coast": "Costa de Marfil",
  "DR Congo": "Rep. Dem. del Congo",
  "Bolivia": "Bolivia",
  "Panama": "Panamá",
  "Nicaragua": "Nicaragua",
  "Dominican Republic": "República Dominicana",
  "Cuba": "Cuba",
  "Puerto Rico": "Puerto Rico",
  "Poland": "Polonia",
  "Slovakia": "Eslovaquia",
  "Slovenia": "Eslovenia",
  "Bosnia": "Bosnia",
  "Montenegro": "Montenegro",
  "Kosovo": "Kosovo",
  "North Macedonia": "Macedonia del Norte",
  "Cyprus": "Chipre",
  "Malta": "Malta",
  "Lithuania": "Lituania",
  "Ireland": "Irlanda",
  "Northern Ireland": "Irlanda del Norte",
  "Israel": "Israel",
  "Indonesia": "Indonesia",
  "Philippines": "Filipinas",
  "Pakistan": "Pakistán",
  "Bangladesh": "Bangladés",
  "Sri Lanka": "Sri Lanka",
  "Nepal": "Nepal",
  "Afghanistan": "Afganistán",
};

export function translateCountry(name) {
  if (!name) return '';
  return COUNTRY_TRANSLATIONS[name]
    ?? COUNTRY_TRANSLATIONS[name.replace(/\s+/g, '-')]
    ?? name;
}

export function fmtLocalDate(d = new Date()) {
  const pad = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export const LIVE_STATUSES = new Set(['1H', '2H', 'HT', 'ET', 'BT', 'P']);

export const STATUS_LABEL = {
  NS:   'Por jugar',
  TBD:  'A confirmar',
  '1H': 'En juego',
  HT:   'Entretiempo',
  '2H': 'En juego',
  ET:   'Prórroga',
  P:    'Penales',
  FT:   'Finalizado',
  AET:  'Fin ET',
  PEN:  'Fin PEN',
  PST:  'Postergado',
  CANC: 'Cancelado',
  SUSP: 'Suspendido',
};

export const isLive = (status) => LIVE_STATUSES.has(status);

export function fmtTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}hs`;
}

export function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
}

export function fmtDateTime(iso) {
  if (!iso) return '';
  return `${fmtDate(iso)} ${fmtTime(iso)}`;
}

export function scoreOrTime(fixture) {
  const s = fixture.fixture.status.short;
  if (s === 'NS' || s === 'TBD') return fmtDateTime(fixture.fixture.date);
  const g = fixture.goals;
  return (g.home === null || g.home === undefined) ? '-' : `${g.home} - ${g.away}`;
}

export function statusLabel(fixture) {
  const s  = fixture.fixture.status.short;
  const el = fixture.fixture.status.elapsed;
  if (s === 'HT') return 'Entretiempo';
  if (isLive(s) && el) return `${el}'`;
  return STATUS_LABEL[s] || s;
}

export async function fetchFixtures(apiUrl, params, clientKey) {
  const url = new URL(`${apiUrl.replace(/\/$/, '')}/fixtures`);
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== '') url.searchParams.set(k, String(v));
  });
  const headers = { Accept: 'application/json' };
  if (clientKey) headers['X-QGH-Client-Key'] = clientKey;
  const res = await fetch(url.toString(), { headers });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const body = await res.json();
  return Array.isArray(body) ? body : (body.response || []);
}

export const LEAGUE_TRANSLATIONS = {
  "World Cup": "Copa del Mundo",
  "UEFA Champions League": "Champions League",
  "UEFA Europa League": "Europa League",
  "UEFA Europa Conference League": "Conference League",
  "Copa America": "Copa América",
  "CONMEBOL Libertadores": "Copa Libertadores",
  "CONMEBOL Sudamericana": "Copa Sudamericana",
  "Copa de la Liga Profesional": "Copa de la Liga",
  "Premier League": "Premier League",
  "La Liga": "La Liga",
  "Serie A": "Serie A",
  "Bundesliga": "Bundesliga",
  "Ligue 1": "Ligue 1",
};

export function translateLeague(name) {
  if (!name) return '';
  return LEAGUE_TRANSLATIONS[name] ?? name;
}

export async function fetchStandings(apiUrl, params, clientKey) {
  const url = new URL(`${apiUrl.replace(/\/$/, '')}/standings`);
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== '') url.searchParams.set(k, String(v));
  });
  const headers = { Accept: 'application/json' };
  if (clientKey) headers['X-QGH-Client-Key'] = clientKey;
  const res = await fetch(url.toString(), { headers });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const body = await res.json();
  return Array.isArray(body) ? body : (body.response || []);
}
